import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface Donor {
  id: string;
  name: string;
  amount: number;
  timeAgo: string;
  message?: string;
}

interface DonorsResponse {
  donors: Donor[];
  source: 'live' | 'cache';
  last_updated: string;
}

export const useRecentDonors = () => {
  return useQuery({
    queryKey: ['recent-donors'],
    queryFn: async (): Promise<DonorsResponse> => {
      const { data, error } = await supabase.functions.invoke('donations-recent');
      
      if (error) {
        console.error('Error fetching recent donors:', error);
        throw new Error('Failed to fetch recent donors');
      }
      
      return data;
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchInterval: 5 * 60 * 1000, // 5 minutes
  });
};